import React, { useEffect, useState } from "react";
import totalSchoolsIcon from "../Assets/Images/Dashboard/Total_schools_icon.svg";
import totalTrainersIcon from "../Assets/Images/Sidebar/Teacher_icon.svg";
import totalVideosIcon from "../Assets/Images/Dashboard/Total_videos_icon.svg";
import videoProgressIcon from "../Assets/Images/Dashboard/video_progress_icon.svg";
import { Pie, PieChart, Cell } from "recharts";
import { GET_SCHOOL_DSSHBOARD_DATA } from "./AllApi";
const SchoolVideoProgress = ({ school_id,schoolDetails,principalName }) => {
  const [apiData, setApiData] = useState([]);
  const token = localStorage.getItem("authToken");

  const SCHOOL_DASHBOARD_API = GET_SCHOOL_DSSHBOARD_DATA(school_id);
  useEffect(() => {
    const fetchData = async () => {
      // console.log('token: ',token)
      try {
        let response = await fetch(SCHOOL_DASHBOARD_API, {
          method: "GET",
          headers: {
            Authorization: `bearer ${token}`,
          },
        });
        if (response.ok) {
          const responseData = await response.json();
          // console.log("data: ", responseData);
          setApiData(responseData);
          // setProgressData(data);
        }
      } catch (err) {
        console.error("Error occured ", err);
      }
    };

    fetchData();
  }, [token,SCHOOL_DASHBOARD_API]);
  const data = [
    { name: "progress", value: apiData?.average_progress },
    { name: "remaining", value: 100 - apiData?.average_progress },
  ];

  return (
    <>
      <section className="school-videoProgress">
        <div className="row school-progress-main-div">
          <div className="col-lg-6 school-Vprogress-first-div">
            <div className="row">
              <div className="col-lg-7">
                <img src={videoProgressIcon} alt="videoProgressIcon" />
                <p className="progressTitle mt-2">Video Watching Progress</p>
                <p className="allTimeTitle">All Time</p>
              </div>
              <div className="col-lg-5">
                <PieChart width={200} height={120}>
                  <Pie
                    data={data}
                    dataKey="value"
                    nameKey="name"
                    cx="40%"
                    cy="50%"
                    innerRadius={50}
                    outerRadius={60}
                    fill="#4991BA"
                    stroke="none"
                    startAngle={90}
                    endAngle={-270}
                  >
                    {data.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={index === 0 ? "#EDB552" : "#4991BA"}
                      />
                    ))}
                  </Pie>
                  <text
                    x="40%"
                    y="50%"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fill="#fff"
                    fontSize={20}
                  >
                    {apiData?.average_progress
                      ? parseFloat(apiData?.average_progress).toFixed(2)
                      : 0}
                    %{/* {Math.round(apiData?.average_progress)} % */}
                    {/* {apiData?.average_progress}% */}
                  </text>
                </PieChart>
              </div>
            </div>
            <div className="totalWatchTimeCard mt-3">
              <span>
                Total watch time:{" "}
                {apiData?.average_watch_time_per_trainer_per_video}
              </span>
            </div>
            <div className="row mt-3">
              <div className="col mb-md-2">
                <div
                  className="card ps-5 school-Vprogress-totalDetails-div"
                  style={{ color:"white" }}
                >
                  <div className="d-flex justify-content-center">
                    <img src={totalSchoolsIcon} alt="totalSchoolsIcon" />
                    <p className="totalNo ms-4 my-auto ">
                      {apiData?.totalTrainers}
                    </p>
                  </div>
                  <div className="main_title text-center mt-4">
                    {" "}
                    Total Trainers
                  </div>
                </div>
              </div>
              <div className="col ">
                <div
                  className="card ps-5 school-Vprogress-totalDetails-div"
                  // style={{ boxShadow: "0px 4px 34px 0px #b6c1c757" }}
                  style={{ color:"white" }}
                >
                  <div className="d-flex justify-content-center">
                    <img src={totalVideosIcon} alt="totalSchoolsIcon" />
                    <p className="totalNo ms-4 my-auto">
                      {apiData?.totalVideos}
                    </p>
                  </div>
                  <div className="main_title text-center mt-4">
                    Total Videos
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 ">
            <div className="school-vprogress-details mt-2">
              <p className="school-Vprogress-title">School Details</p>
              <div>
                <p className="school-Vprogress-sub-title">School Name</p>
                <p className="school-Vprogress-desc">
                  {schoolDetails?.school_name
                    ? schoolDetails?.school_name
                    : "-"}
                </p>
              </div>
              <div>
                <p className="school-Vprogress-sub-title">School Location</p>
                <p className="school-Vprogress-desc">
                  {schoolDetails?.school_loc ? schoolDetails?.school_loc : "-"}
                </p>
              </div>
              <div>
                <p className="school-Vprogress-sub-title">Principal Name</p>
                <p className="school-Vprogress-desc">
                  {schoolDetails?.princi_name
                    ? schoolDetails?.princi_name
                    : "-"}
                </p>
              </div>
              <div>
                <p className="school-Vprogress-sub-title">Mobile Number</p>
                <p className="school-Vprogress-desc">
                  {schoolDetails?.princi_mobile
                    ? schoolDetails?.princi_mobile
                    : "-"}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="row mt-3">
          <div className="col ">
            <div
              className="card ps-5 school-Vprogress-totalDetails-div"
              style={{ boxShadow: "0px 4px 34px 0px #b6c1c757" }}
            >
              <div className="d-flex justify-content-center">
                <img src={totalSchoolsIcon} alt="totalSchoolsIcon" />
                <p className="totalNo ms-4 my-auto ">{apiData?.totalSchools}</p>
              </div>
              <div className="main_title text-center mt-4"> Total Trainers</div>
            </div>
          </div>
          <div className="col ">
            <div
              className="card ps-5 school-Vprogress-totalDetails-div"
              style={{ boxShadow: "0px 4px 34px 0px #b6c1c757" }}
            >
              <div className="d-flex justify-content-center">
                <img src={totalVideosIcon} alt="totalSchoolsIcon" />
                <p className="totalNo ms-4 my-auto">{apiData?.totalVideos}</p>
              </div>
              <div className="main_title text-center mt-4">Total Videos</div>
            </div>
          </div>
        </div> */}
      </section>
    </>
  );
};

export default SchoolVideoProgress;
